import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { GeneralDashboardFieldStack } from "./GeneralDashboardFieldStack";

interface GeneralReservoirManagementCardProps {
  data: { items: Record<string, unknown>[] } | null;
  onMenuClick: () => void;
}

const RESERVOIR_PREVIEW_FIELDS = [
  "occupiedArea",
  "totalVolume",
  "totalOccupiedVolume",
  "availableVolume",
  "waterLevel",
] as const;

const RESERVOIR_LABEL_KEYS: Record<(typeof RESERVOIR_PREVIEW_FIELDS)[number], string> = {
  occupiedArea: "admin.structures.reservoirManagement.label.occupiedArea",
  totalVolume: "admin.structures.reservoirManagement.label.totalVolume",
  totalOccupiedVolume: "admin.structures.reservoirManagement.label.totalOccupiedVolume",
  availableVolume: "admin.structures.reservoirManagement.label.availableVolume",
  waterLevel: "admin.structures.reservoirManagement.label.waterLevel",
};

export const GeneralReservoirManagementCard: React.FC<
  GeneralReservoirManagementCardProps
> = ({ data, onMenuClick }) => {
  const { translate } = useLocalization();

  const item = data?.items && data.items.length > 0 ? data.items[0] : null;

  const fields = RESERVOIR_PREVIEW_FIELDS.map((fieldName) => ({
    labelKey: RESERVOIR_LABEL_KEYS[fieldName],
    value: item ? item[fieldName] : null,
  }));

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.reservoirManagement.title")}
      titleVariant="large"
      onMenuClick={onMenuClick}
      className="h-full"
      menuTestId="more-options-manejo-do-reservat-rio"
    >
      {item ? (
        <GeneralDashboardFieldStack fields={fields} />
      ) : (
        <div className="flex h-full flex-1 items-center justify-center text-sm text-muted-foreground">
          {translate("general.dashboard.emptyValue")}
        </div>
      )}
    </GeneralDashboardCard>
  );
};
